import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-homepage',
    templateUrl: './homepage.component.html'
})
export class HomepageComponent{

	algoliaApiKey = environment.algoliaApiKey;
	algoliaAppId = environment.algoliaAppId;
	algoliaIndexName = environment.algoliaIndexName;
	algoliaUrlSync = environment.algoliaUrlSync;
	algoliaIndexSortByNameAsc = environment.algoliaIndexSortByNameAsc;

	now: any;

	countDownText:any = {
	    Year: 'A',
	    Month: 'm',
	    Weeks: "S",
	    Days: "j",
	    Hours: "h",
	    Minutes: "m",
	    Seconds: "s",
	    MilliSeconds: "Ms"
  	};

  	constructor() { 

	    setInterval(() => {
	        this.now =  new Date();
	        this.now = this.now.toISOString();
	     }, 1000);
  	}
}


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/homepage/homepage.component.ts